import React from 'react'
import { Carousel, About, ImageTitleButtonBlock, Customers, News, ContactForm, TitleButtonBlock } from './../../components'
import { getHome } from './../../core/api/home-provider'
import { Row, Col, Container } from 'react-bootstrap'

const Home = () => {

    const [homeData, setHomeData] = React.useState()

    React.useEffect(() => {
        getHome().then((response) => setHomeData(response.data))
    },[])

    return (
        <>
            {
                homeData && (
                    <>
                        <Carousel slides={homeData.slides}/>
                        <Container fluid className='px-0'>
                            <Row className='mx-0 px-0'>
                                <Col xs={12}>
                                    {
                                        homeData?.about.map((about, index) => (
                                            <Row className='my-5 mx-0 px-0'>
                                                <Col xs={12} md={{ span: 10, offset: 1 }}>
                                                    <About
                                                        key={index}
                                                        image_group={about.image_group}
                                                        content_group={about.content_group}
                                                        margin='5% 0px'
                                                        alignment={about.alignment}
                                                    />
                                                </Col>
                                            </Row>
                                        ))
                                    }
                                </Col>
                            </Row>
                            
                            <Row className='mx-0 px-0 my-5'>
                                <Col xs={12} className='px-0'>
                                    <ImageTitleButtonBlock
                                        image={homeData.block_image_title_button.image}
                                        title={homeData.block_image_title_button.title}
                                        button={homeData.block_image_title_button.button}
                                    />
                                </Col>
                            </Row>

                            <Row className='my-5 px-0 mx-0'>
                                <Col xs={12} className='px-0'>
                                    <Customers
                                        customers={homeData.customers}
                                        title='Clientes'
                                    />
                                </Col>
                            </Row>

                            <Row>
                                <Col xs={12} className='px-0'>
                                    <News
                                        title={homeData.featuredNews?.title}
                                        text={homeData.featuredNews?.content}
                                        date={homeData.featuredNews?.date}
                                        image={homeData.featuredNews?.image}
                                        button={homeData.featuredNews?.button}
                                    />
                                </Col>
                            </Row>

                            <Row className='my-5'>
                                <Col xs={12} className='px-0'>
                                    <ContactForm title='Contato'/>
                                </Col>
                            </Row>


                            
                                    <TitleButtonBlock
                                        title={homeData.block_text_button.title}
                                        button={homeData.block_text_button.button}
                                    />
                            
                        </Container>

                    </>
                )
            }

        </>
    )
}

export default Home